import { Alert, Button, notification } from "antd";
import { useContext, useEffect, useRef, useState, useCallback } from "react";
import { BiChevronRight } from "react-icons/bi";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { restartSession } from "../../api";
import { LanguageContext } from "../../contexts/languageContext";
import { Auth } from "../../contexts/ridersUserContext";
import socket from "../../utils/sockets";
// import AppTour from "../app-tour/AppTour";
import { TourStep } from "../app-tour/type";
import { setCookie } from "../shared/Cookie";
import { DangerIcon } from "../shared/icons/icons";
import { Panel, Screen, Simulation, Tablist, Toolbar } from "../vs-code";
import ChapterSideBar from "../vs-code/ChapterSideBar";
import { useWorkspaces } from "../vs-code/helpers/workspaces";
import { ChapterWorkspaceType, ThemeType } from "../vs-code/types";
import { sessionSocket } from "../../singletons/SessionSocket"
import { isArray } from "lodash";
import { handleWsAchieveResponse } from "../../utils/pendingAchievements";
import { isPublicProject } from "../../utils/publicProjects";

const EditorLayout = () => {
  const [panelOptions, setPanelOptions] = useState<any>({});
  // const [reated, setReated] = useState<boolean>(false);
  const [alertHover, setAlertHover] = useState<boolean>(false);
  const splitPaneRef = useRef();
  const [isResizing, setIsResizing] = useState(false);
  const [showNextChapter, setShowNextChapter] = useState(false);

  const {
    workspaces,
    activeChapter,
    theme,
    setTheme,
    collapsedSidebar,
    setCollapsedSidebar,
    yamlData,
    documentationRef,
  } = useContext<any>(Screen.context);
  const { getTabs } = useWorkspaces();

  // Select button with id of chapter-sidebar-next button with useRef
  const nextButtonRef = useRef<HTMLButtonElement>();
  const nextButton = nextButtonRef.current;

  const {
    mode,
    shutDown,
    setShutDown,
    community,
    accessTokenKey,
    projectType,
    haveOverrides,
    project,
    modifiedNotification,
    user,
    modifiedFiles,
    isBranchOwner,
  } = useContext<any>(Auth.context);

  const { language } = useContext<any>(LanguageContext);

  const params = useParams();
  const [workspaceViews, setWorkspaceViews] = useState([]);
  // select the workspaces due to json
  const [chapterWorkspace, setChapterWorkspace] =
    useState<ChapterWorkspaceType>({
      documentation: false,
      powerpoint: false,
      code: false,
      simulation: false,
      QA: false,
    });

  const selectChapterWorkspaces = (_workspaces: ChapterWorkspaceType) => {
    setChapterWorkspace(_workspaces);
  };

  const onDragStart = () => {
    setIsResizing(true);
  };

  const onDragEnd = () => {
    setIsResizing(false);
  };

  // set views
  useEffect(() => {
    const _tabs: any = [];
    const codeSource = activeChapter?.cells.find(
      (x: any) => x.type === "Code"
    )?.sourceCode;
    const simulationSource = activeChapter?.cells.find(
      (x: any) => x.type === "Simulation"
    )?.sourceCode;

    if (
      chapterWorkspace.code &&
      (chapterWorkspace.documentation || chapterWorkspace.powerpoint) &&
      chapterWorkspace.simulation
    ) {
      setCollapsedSidebar(true);
      _tabs.push(
        {
          id: "A",
          tabs: [getTabs("code", codeSource), getTabs("documentation", "")],
        },
        {
          id: "B",
          tabs: [
            getTabs("simulation", simulationSource ? simulationSource : ""),
          ],
        }
      );
    } else if (chapterWorkspace.simulation) {
      setCollapsedSidebar(true);
      Object.keys(chapterWorkspace).forEach((key: any) => {
        if (chapterWorkspace[key as keyof ChapterWorkspaceType]) {
          if (key !== "simulation") {
            if (_tabs.length > 0) {
              _tabs[0] = {
                id: "A",
                tabs: [
                  ..._tabs[0].tabs,
                  getTabs(key, key === "code" ? codeSource : ""),
                ],
              };
            } else {
              _tabs.push({
                id: "A",
                tabs: [getTabs(key, key === "code" ? codeSource : "")],
              });
            }
          }
        }
      });
      _tabs.push({
        id: "B",
        tabs: [getTabs("simulation", simulationSource ? simulationSource : "")],
      });
    } else {
      setCollapsedSidebar(false);
      Object.keys(chapterWorkspace).forEach((key: any) => {
        if (chapterWorkspace[key as keyof ChapterWorkspaceType]) {
          if (_tabs.length > 1) {
            _tabs[0] = {
              id: "A",
              tabs: [
                ..._tabs[0].tabs,
                getTabs(key, key === "code" ? codeSource : ""),
              ],
            };
          } else {
            _tabs.push({
              id: _tabs.length > 0 ? "B" : "A",
              tabs: [getTabs(key, key === "code" ? codeSource : "")],
            });
          }
        }
      });
    }
    console.log("workspaceViews", _tabs);
    setWorkspaceViews(_tabs);
    //eslint-disable-next-line
  }, [chapterWorkspace, workspaces, activeChapter]);

  // inject drag button to split
  useEffect(() => {
    const resizer = document.querySelector(".Resizer");
    if (resizer && !resizer?.querySelector("button")) {
      resizer?.classList.add("flex", "w-5", "items-center", "justify-center");
      const dragButton = document.createElement("button");
      dragButton.classList.add(
        "bg-[#C3D8F3]",
        "rounded-full",
        "cursor-default",
        "dragButton"
      );
      const ul = document.createElement("ul");
      ul.classList.add(
        "flex",
        "flex-col",
        "w-full",
        "h-fit",
        "py-2",
        "px-1",
        "space-y-1"
      );
      const li = document.createElement("li");
      li.classList.add("w-0", "h-1.5", "rounded-full", "bg-white");
      for (let i = 1; i <= 3; i++) {
        const li = document.createElement("li");
        li.classList.add("w-1", "h-1", "rounded-full", "bg-white");
        ul.appendChild(li);
      }
      dragButton.appendChild(ul);
      resizer?.appendChild(dragButton);
    }
  });

  useEffect(() => {
    let resizeTimer: any;
    if (isResizing) {
      resizeTimer = setInterval(() => {
        window.getBlocklyWorkspace?.((workspace: any) => {
          window.Blockly.svgResize(workspace);
        });
      }, 10);
    } else {
      clearInterval(resizeTimer);
      window.getBlocklyWorkspace?.((workspace: any) => {
        window.Blockly.svgResize(workspace);
      });
    }
    return () => clearInterval(resizeTimer);
  }, [isResizing]);

  useEffect(() => {
    if (window.Blockly && window.Blockly.WidgetDiv) {
      window.Blockly.WidgetDiv.hide();
    }
    setTimeout(() => {
      const blocklySvg = document.querySelector(
        ".blocklySvg"
      ) as HTMLElement | null;
      if (blocklySvg) {
        // svgWidth = blocklySvg.getBoundingClientRect().width;
        const pane = document.querySelector(".Pane1") as HTMLDivElement | null;
        if (pane) {
          // pane.style.width = svgWidth.toString() + 'px';
          blocklySvg.setAttribute("width", pane.clientWidth + "px");
          window.getBlocklyWorkspace?.((workspace: any) => {
            const selectedBlock = window.Blockly.selected;
            if (selectedBlock) {
              selectedBlock.unselect();
              selectedBlock.inputList.forEach((input: any) => {
                input.fieldRow.forEach((field: any) => {
                  if (
                    field instanceof window.Blockly.FieldTextInput ||
                    field instanceof window.Blockly.FieldNumber
                  ) {
                    field.getInputElement().blur(); // Odaklanmayı kaldır
                  }
                });
              });
              const inputElements = selectedBlock.inputList.flatMap(
                (input: any) => input.fieldRow
              );
              inputElements.forEach((field: any) => {
                if (
                  field instanceof window.Blockly.FieldTextInput ||
                  field instanceof window.Blockly.FieldNumber
                ) {
                  const inputElement = field.getInputElement();
                  inputElement.click(); // Focus'u kaldır
                }
              });
            }
            window.Blockly.svgResize(workspace);
          });
        }
      }
    }, 200);
  }, [collapsedSidebar]);

  const checkpointSubchapter = "Robotun İleri Hareketi";

  useEffect(() => {
    socket(project.session_id);


    // get message from iframe
    window.addEventListener("message", (event) => {
      const data = JSON.parse(event.data);
      if (data.nextChapter) {
        setShowNextChapter(true);
      } else {
        setShowNextChapter(false);
      }
    });

    return () => {
      window.removeEventListener("message", () => {
        // setShowNextChapter(false);
      });
    };
  }, []);

  const postMessage = useCallback((ref: any, msg: any) => {
    const message = JSON.stringify(msg);

    if (isArray(ref)) {
      ref.forEach((r) => {
        r.current?.contentWindow.postMessage(message, "*");
      });
    } else {
      ref.current?.contentWindow.postMessage(message, "*");
    }
  }, []);

  useEffect(() => {
    sessionSocket.registerEventListeners("message", (event) => {
      const data = JSON.parse((event as MessageEvent).data);
      if (data.type === "achieve_result") {
        handleWsAchieveResponse(data, (id) => {
          postMessage(documentationRef, {
            action: "achieve",
            data: id,
          });
        });
      }
    });
    return () => {
      sessionSocket.removeEventListeners("message");
    }
  }, [documentationRef])

  useEffect(() => {
    if (!project) return
    console.log("SessionSocket connect.");
    sessionSocket.registerEventListeners("shutdown", () => { setShutDown(true) });

    sessionSocket.connect(project.session_id);

    return () => {
      sessionSocket.removeEventListeners("shutdown");
      sessionSocket.disconnect();
    }
  }, [project?.session_id]);


  useEffect(() => {
    document.body.classList.remove("light", "dark");
    document.body.classList.add(theme);
    localStorage.setItem("riders-theme", theme);
  }, [theme]);

  const toggleTheme = (theme: ThemeType) => {
    setTheme(theme);
  };

  useEffect(() => {
    if (modifiedNotification && yamlData.chapters) {
      notification.open({
        key: "modified",
        message: "",
        description: (
          <div style={{ lineHeight: "1.2", fontSize: "14px" }}>
            {language === "EN" ? (
              <div>
                <span>
                  Your code has been modified by {modifiedNotification}.
                  <br />
                  Please check your code.
                  <br />
                  <br />
                </span>
                {modifiedFiles.map((file: string) => (
                  <div key={file}>
                    {findSimulationNames(yamlData, file)?.en}
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <span>
                  Kodunuz {modifiedNotification} tarafından değiştirildi.
                  <br />
                  Lütfen kodunuzu kontrol edin.
                  <br />
                  <br />
                </span>
                {modifiedFiles.map((file: string) => (
                  <div key={file}>
                    {findSimulationNames(yamlData, file)?.tr}
                  </div>
                ))}
              </div>
            )}
          </div>
        ),
        duration: null,
        style: {
          backgroundColor: "#6F78E7",
          color: "white",
          padding: "4px 8px 4px 8px",
        },
        placement: "bottomRight",
        icon: <DangerIcon size={40} />,
      });
    }
  }, [modifiedNotification, yamlData]);

  const tourList: { name: string[]; step: TourStep }[] = [
    {
      name: ["welcome"],
      step: {
        target: ".page",
        content: "Welcome to the Riders Editor!",
        placement: "center",
      },
    },
    {
      name: ["sidebar"],
      step: {
        target: "#side-bar-container",
        content:
          "Here, you can view a list of chapters and modules and change them as you see fit.",
        placement: "right",
      },
    },
    {
      name: ["simulation"],
      step: {
        target: ".simulation-tab",
        content: "Here, you can view the simulation of the project.",
        placement: "left",
      },
    },
    {
      name: ["blockly"],
      step: {
        target: ".code-tab",
        content: "Here, you can view the code of the project.",
        placement: "right",
      },
    },
    {
      name: ["iframe"],
      step: {
        target: ".documentation-tab",
        content: "Here, you can view the documentation of the project.",
        placement: "right",
      },
    },
    {
      name: ["powerpoint"],
      step: {
        target: ".powerpoint-tab",
        content: "Here, you can view the powerpoint of the project.",
        placement: "right",
      },
    },
  ];

  const getTourSteps = (): TourStep[] => {
    const workspaceSteps = workspaceViews.map((workspace: any) => {
      return workspace.tabs.map((tab: any) => {
        return tourList.find((tour) => tour.name.includes(tab.type))?.step;
      });
    });

    console.log("workspaceSteps", ...workspaceSteps.flat());
    return [
      tourList[0].step,
      tourList[1].step,
      ...workspaceSteps.flat().filter((step) => step !== undefined),
    ];
  };

  return (
    <div className="side-bar-container h-screen bg-editor-background dark:bg-vs-dark-background flex items-center font-alata pr-4">
      {/* <AppTour
        tourSteps={getTourSteps()}
        dependency={
          workspaceViews.length > 1 &&
          chapterWorkspace.code &&
          (chapterWorkspace.documentation || chapterWorkspace.powerpoint) &&
          chapterWorkspace.simulation
        }
      /> */}

      <div className="flex w-full h-[95%] space-x-2 page">
        <Toolbar
          theme={theme}
          setPanel={setPanelOptions}
          panel={panelOptions}
          className="flex-shrink-0"
          toggleTheme={toggleTheme}
        />
        <ChapterSideBar
          selectChapterWorkspaces={selectChapterWorkspaces}
          nextButtonRef={nextButtonRef}
        />
        <Panel
          title={panelOptions.title}
          open={panelOptions.open}
          children={panelOptions.children}
          settings={panelOptions.settings}
          className="flex-shrink-0"
        />
        <div className="flex-grow max-h-full flex flex-col">
          {!isBranchOwner && !isPublicProject() && (
            <Alert
              rootClassName="mb-2 rounded-lg"
              onMouseEnter={() => setAlertHover(true)}
              onMouseLeave={() => setAlertHover(false)}
              message={
                language === "EN" ? (
                  <span className="text-sm p-0 m-0">
                    {!alertHover
                      ? `You are currently viewing the project shared by ${user?.username}.`
                      : `You are currently viewing the project shared by ${user?.username}. | The changes you make will be visible to the student.`}
                  </span>
                ) : (
                  <span className="text-sm p-0 m-0">
                    {!alertHover
                      ? `Şu anda ${user?.username} tarafından paylaşılan projeyi görüntülüyorsunuz.`
                      : `Şu anda ${user?.username} tarafından paylaşılan projeyi görüntülüyorsunuz. | Yaptığınız değişikler öğrenci tarafından görüntülenebilecektir.`}
                  </span>
                )
              }
              banner
              closable
              className="h-8"
            />
          )}
          {mode === "preview" && (
            <Alert
              rootClassName="mb-2 rounded-lg"
              onMouseEnter={() => setAlertHover(true)}
              onMouseLeave={() => setAlertHover(false)}
              message={
                language === "EN" ? (
                  <span className="text-sm p-0 m-0">
                    {!alertHover
                      ? "You are currently in preview mode, show more information."
                      : "You are currently in preview mode. You can only vies and edit the student's course page. But you can't save & publish the project"}
                  </span>
                ) : (
                  <span className="text-sm p-0 m-0">
                    {!alertHover
                      ? "Şu anda önizleme modundasınız, daha fazla bilgi göster."
                      : "Şu anda önizleme modundasınız. Öğrencinin ders ekranını yalnızca görüntüleyebilir ve düzenleyebilirsiniz. Ancak ders ekranında yaptığınız değişiklikleri kaydedemez ve yayınlayamazsınız."}
                  </span>
                )
              }
              banner
              closable
              className="h-8"
            />
          )}
          {/*// @ts-ignore*/}

          <div className={`w-full relative overflow-hidden h-full`}>
            {haveOverrides && (
              <Alert
                onMouseEnter={() => setAlertHover(true)}
                onMouseLeave={() => setAlertHover(false)}
                message={
                  <span className="text-sm p-0 m-0">
                    {!alertHover
                      ? "You have local overrides, show more information."
                      : "You have local overrides. | More information about local overrides."}
                  </span>
                }
                banner
                closable
                className="h-8 mb-2"
              />
            )}
            <div className="fit flex relative space-x-2 editor-splitter">
              <SplitPane
                split="vertical"
                defaultSize={
                  workspaceViews.length === 1
                    ? "100%"
                    : collapsedSidebar
                      ? "33%"
                      : "50%"
                }
                paneStyle={
                  workspaceViews.length === 1
                    ? { minWidth: "100%", maxWidth: "100%" }
                    : { minWidth: "25%", maxWidth: "99%" }
                }
                pane1Style={{ paddingRight: "0px" }}
                pane2Style={{ paddingLeft: "0px" }}
                resizerStyle={
                  workspaceViews.length === 1
                    ? { width: "0px", cursor: "col-resize" }
                    : { width: "16px", cursor: "col-resize" }
                }
                // @ts-ignore
                ref={splitPaneRef}
                onDragStarted={onDragStart}
                onDragFinished={onDragEnd}
              >
                {workspaceViews
                  .filter((w: any) => {
                    return w.tabs.find((t: any) => t.type !== "simulation");
                  })
                  .map((workspace: any, index: number) => (
                    <Tablist
                      key={index}
                      style={{ gridArea: workspace.id }}
                      tabs={workspace.tabs}
                      checkPoint={checkpointSubchapter === activeChapter?.name}
                      workspaceId={workspace.id}
                      isResizing={isResizing}
                    />
                  ))}
                <Simulation
                  style={{
                    display: (workspaceViews as any).some((tb: any) =>
                      tb.tabs.some((t: any) => t.type === "simulation")
                    )
                      ? "block"
                      : "none",
                  }}
                  checkPoint={checkpointSubchapter === activeChapter?.name}
                  isResizing={isResizing}
                  workspaceId={"simulation"}
                />
              </SplitPane>
            </div>

            {showNextChapter && (
              <button
                className="py-2 px-3 flex justify-center items-center space-x-2 bg-editor-green shadow absolute bottom-4 right-8 rounded-lg text-white"
                onClick={() => {
                  nextButton && nextButton.click();
                  setShowNextChapter(false);
                }}
              >
                <span>
                  <FormattedMessage id="buttonNext" />
                </span>
                <BiChevronRight size={24} />
              </button>
            )}
          </div>
        </div>

        {shutDown && community === "riders" && (
          <div
            className="absolute w-screen h-screen top-0 left-0 flex justify-center items-center"
            id="cover-screen-expires"
            style={{
              backgroundColor: "rgba(0,0,0,0.5)",
              backdropFilter: "blur(4px)",
              zIndex: 999,
            }}
          >
            <Alert
              message={<FormattedMessage id="sessionExpired" />}
              description={
                <div className="flex flex-col space-y-4">
                  {/* <p><FormattedMessage id="sessionExpired" /></p> */}
                  <span>
                    {/* <p>
                            <FormattedMessage id="appreciateFeedback" />
                          </p> */}
                    <p className="pt-2">
                      <FormattedMessage id="restartSession" />
                    </p>
                    <span className="pr-4 pt-4 flex items-center justify-between w-full pointer-events-auto">
                      <Button
                        onClick={async () => {
                          const token = params["token"];
                          const data = await restartSession(token || "");

                          setCookie(
                            accessTokenKey,
                            data,
                            new Date().getTime() + 1000 * 60 * 3
                          );
                          window.location.reload();
                        }}
                      >
                        <FormattedMessage id="restart" />
                      </Button>
                      {/* {!reated ? (
                        <Rate
                            character={<FaRobot/>}
                            allowHalf
                            onChange={() => setReated(true)}
                        />
                    ) : (
                        <FaHeart className="text-red text-xl"/>
                    )} */}
                    </span>
                  </span>
                </div>
              }
              type="info"
              className="w-96"
              showIcon
            />
          </div>
        )}
      </div>
    </div>
  );
};

function findSimulationNames(
  module: any,
  targetCode: string
): { en: string; tr: string } | null {
  const fileName = targetCode
    .split("/")
  [targetCode.split("/").length - 1].split(".")[0];

  let moduleCounter = 1;
  let chapterCounter = 1;
  for (const chapter of module.chapters) {
    if (chapter.subchapters) {
      for (const subchapter of chapter.subchapters) {
        if (subchapter.cells) {
          for (const cell of subchapter.cells) {
            if (cell.type === "Simulation" && cell.sourceCode === fileName) {
              return {
                en: `${moduleCounter}.${chapterCounter} ${subchapter.name}`,
                tr: `${moduleCounter}.${chapterCounter} ${subchapter.name}`,
              };
            }
          }
        }
        chapterCounter++;
      }
    }
    moduleCounter++;
    chapterCounter = 1;
  }
  return null;
}

export default EditorLayout;
